module.exports = __webpack_public_path__ + "static/headshot-forest-monsen-3x.6953c754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-forest-monsen-3x.jpg
// module id = 520
// module chunks = 152909308826437